import { authorizedOnly } from 'SharedDir/router/helpers';
import { RouteRecordRaw } from 'vue-router';

const queryString: RouteRecordRaw = {
  path: 'query-string',
  name: 'components-query-string',
  component: () => import('./QueryString.vue'),
};

const fieldParams: RouteRecordRaw = {
  path: 'field-params',
  name: 'components-field-params',
  component: () => import('./FieldParams.vue'),
};

const fields: RouteRecordRaw = {
  path: 'fields',
  name: 'components-fields',
  meta: authorizedOnly(),
  component: () => import('./Fields.vue'),
};

const hierarchy: RouteRecordRaw = {
  path: 'hierarchy',
  name: 'components-hierarchy',
  meta: authorizedOnly(),
  component: () => import('./Hierarchy.vue'),
};

const common: RouteRecordRaw = {
  path: 'common',
  name: 'components-common',
  component: () => import('./Common/ComponentsIndex.vue'),
};
export const showUIKit = (baseRoutes) => {
  if (process.env.NODE_ENV === 'development') {
    const UIKit = {
      path: 'ui-kit',
      name: 'ui-kit',
      component: () => import('./Index.vue'),
      children: [common, fieldParams, fields, queryString, hierarchy],
      redirect: { name: 'components-common' },
    };

    baseRoutes.unshift(UIKit);
  }
  return baseRoutes;
};
